import { useEffect } from 'react'

// Añadir la declaración para TypeScript
declare global {
  interface Window {
    dataLayer: any[]
  }
}

// Exportamos la interfaz para poder reutilizarla en otros archivos
export interface EnvVariables {
  MODE?: 'production' | 'development' | 'test'
  SENTRY_DSN?: string
  ALLOW_INDEXING?: 'true' | 'false'
  TAG_MANAGER_ID?: string
}

/**
 * Hook para inicializar y gestionar Google Tag Manager
 * @param tagManagerId ID de Google Tag Manager
 * @param consentGiven Estado del consentimiento de cookies
 */
export function useTagManager(tagManagerId: string | undefined, consentGiven: boolean) {
  // Inicializar Google Tag Manager con configuración basada en consentimiento
  useEffect(() => {
    if (process.env.NODE_ENV === 'production' && tagManagerId?.length) {
      // Importar TagManager dinámicamente para evitar errores en SSR
      import('react-gtm-module')
        .then((TagManagerModule) => {
          const TagManager = TagManagerModule.default

          // Configuración básica de GTM
          const tagManagerArgs = {
            gtmId: tagManagerId,
            // Configurar dataLayer inicial con el estado de consentimiento
            dataLayer: {
              // Información sobre el entorno
              environment: process.env.NODE_ENV,

              // Estado de consentimiento simplificado
              consentGiven,

              // Evento para que GTM pueda escuchar y actuar en consecuencia
              event: 'consent_initialized',
            },
          }

          // Inicializar GTM con la configuración
          TagManager.initialize(tagManagerArgs)
        })
        .catch((err) => {
          console.error('Error al cargar TagManager:', err)
        })
    }
  }, [tagManagerId, consentGiven])

  // Actualizar el dataLayer cuando cambia el estado de consentimiento
  useEffect(() => {
    if (
      process.env.NODE_ENV === 'production' &&
      tagManagerId?.length &&
      window.dataLayer
    ) {
      // Actualizar dataLayer cuando cambia el consentimiento
      window.dataLayer.push({
        event: 'consent_update',
        consentGiven,
      })
    }
  }, [tagManagerId, consentGiven])
}
